import { render } from "./PDFParadigmIntro.vue?vue&type=template&id=223456b6&ts=true"
import script from "./PDFParadigmIntro.vue?vue&type=script&lang=ts"
export * from "./PDFParadigmIntro.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__